/*
 * @Author: wuqinfa
 * @Date: 2024-02-19 15:49:00
 * @LastEditors: wuqinfa
 * @Description: 
 */
import request from '@/utils/request';

/**
 * 根据leadsID查询手机号
 */
export async function getPhone(params: any) {
  return request('/crm-campus/orgLeads/getPhone', {
    method: 'GET',
    params: params
  });
}

/**
 * 机构leads分页查询接口
 */
export async function orgLeadsPage(params: any) {
  return request('/crm-campus/orgLeads/page', {
    method: 'POST',
    data: params,
  });
}

/**
 * 删除机构leads接口
 */
export async function orgLeadsRemove(params: any) {
  return request('/crm-campus/orgLeads/remove', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 机构leads提交入库接口
 */
export async function orgLeadsSubmit(params: any) {
  return request('/crm-campus/orgLeads/submit', {
    method: 'POST',
    params: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 机构leads分页查询接口
 */
export async function schoolQuery(params: any) {
  return request('/crm-campus/school/query', {
    method: 'GET',
    params: params,
  });
}

/**
 * 撞库查询导入接口
 */
export async function importImpact(params: any) {
  return request('/crm-campus/orgLeads/importImpact', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/**
 * 获取机构当天剩余撞库数
 */
export async function remainingCount(params: any) {
  return request('/crm-campus/orgLeads/remainingCount', {
    method: 'GET',
    params: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 号码导入接口
 */
export async function importPhone(params: any) {
  return request('/crm-campus/orgLeads/importPhone', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/**
 * 问卷导入接口
 */
export async function importSurvey(params: any) {
  return request('/crm-campus/orgLeads/importSurvey', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/**
 * 一键提交入库接口
 */
export async function batchSubmit(params: any) {
  return request('/crm-campus/orgLeads/batchSubmit', {
    method: 'POST',
    data: params,
  });
}

/**
 * 获取当前待确认入库leads数
 */
export async function notSubmitCount(params: any) {
  return request('/crm-campus/orgLeads/notSubmitCount', {
    method: 'POST',
    data: params,
  });
}

/**
 * 发送验证码
 */
export async function sendSmsCode(params: any) {
  return request('/crm-campus/orgLeads/sendSmsCode', {
    method: 'POST',
    params: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 机构leads分页导出接口
 */
export async function dataExport(params: any) {
  return request('/crm-campus/orgLeads/export', {
    method: 'POST',
    data: params,
    responseType: 'blob',
  });
}

/**
 * 关联学校
 */
export async function getScopeSchool(params: any) {
  return request('/crm-campus/school/getScopeSchool', {
    method: 'GET',
    params: params
  });
}
